import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ActualizacionApp } from './pwa/CapaApp';
import { resolverEntrada, ofrecePresentacionLocal } from './showroom/entrada';
import { estaInstalada } from './pwa/instalar';
// Las fuentes de la FIP, servidas por la app y no por Google: asi entran al
// precache y la app instalada las tiene sin senal. Solo el subconjunto latino
// (alcanza para a, n y el ordinal), para no bajar alfabetos que no se usan.
import '@fontsource/bebas-neue/latin-400.css';
import '@fontsource/titillium-web/latin-400.css';
import '@fontsource/titillium-web/latin-600.css';
import '@fontsource/titillium-web/latin-700.css';
import './index.css';

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Falta <div id="root"> en index.html');

const Presentacion = lazy(() => import('./showroom/Presentacion').then(m => ({ default: m.Presentacion })));
const Muestra = lazy(() => import('./showroom/Muestra').then(m => ({ default: m.Muestra })));
const rutaActual = window.location.pathname;
if (rutaActual !== '/' && rutaActual.endsWith('/')) {
  window.history.replaceState(null, '', `${rutaActual.replace(/\/+$/, '')}${window.location.search}${window.location.hash}`);
}
const ruta = window.location.pathname;
const entrada = resolverEntrada(window.location.hostname, ruta);
if (entrada.tipo === 'redirigir') window.location.replace(entrada.destino);
const grupoConocido = (() => { try { return localStorage.getItem('rankealo.grupoConocido') === 'si'; } catch { return false; } })();
const mostrarPresentacion = entrada.tipo === 'presentacion'
  || (ofrecePresentacionLocal(window.location.hostname, ruta, estaInstalada(), grupoConocido)
    && !document.documentElement.hasAttribute('data-estilo-demo'));

createRoot(raiz).render(
  <StrictMode>
    <ActualizacionApp />
    <Suspense fallback={<p className="p-5">Abriendo Rankealo…</p>}>
      {entrada.tipo === 'redirigir' ? null : mostrarPresentacion ? <Presentacion /> : entrada.tipo === 'muestra' ? <Muestra /> : <App />}
    </Suspense>
  </StrictMode>,
);
